import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { TrainingAPI } from "../../../api/TrainingAPI";
import { AllQuestions } from "./AllQuestions";
import MySurvey from "./MySurvey/MySurvey";

import "./styles.css";

let trainingAPI = new TrainingAPI();
export const WellnessSurvey = () => {
  const [allQuestions, setAllQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState({});
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [deleteLast, setDeleteLast] = useState(false);
  const [backupQuestions, setBackupQuestions] = useState([]);

  const getAllquestions = async () => {
    const allquestions = await trainingAPI.getAllQuestions();
    return allquestions;
  };

  const getTeamSurvey = async () => {
    const teamSurvey = await trainingAPI.getTeamSurvey();
    return teamSurvey;
  };

  const setWellnessQuestion = async (deleteL) => {
    let uniqueArray = Array.from(
      new Set(selectedAnswers.map((item) => item.questionId))
    ).map((questionId) =>
      selectedAnswers.find((item) => item.questionId === questionId)
    );

    const response = await trainingAPI.setWellness(uniqueArray,deleteL);
    if(deleteL && uniqueArray.length === 0){
      setDeleteLast(false)
    }
    return response;
  };

  const handleDelete = (questionId) => {
    let new_answers = selectedAnswers.filter(({ questionId: qId }) => questionId !== qId)
    if (new_answers.length == 0){
      setDeleteLast(true)
    }
    setSelectedAnswers(new_answers);
  };

  const categorySet = new Set(allQuestions?.map((item) => item.category));
  const categories = Array.from(categorySet).sort();
  categories.sort((a, b) => {
    if (a === "Other" && b !== "Other") return 1; // "Other" should come after everything else
    if (b === "Other" && a !== "Other") return -1; // Everything else should come before "Other"
    return a.localeCompare(b); // Sort alphabetically
  });

  const filteredQuestions = allQuestions.reduce(
    (acc, question) => {
      const category = categories.find((cat) => cat === question.category);
      if (category) {
        acc[category.toLowerCase()].push(question);
      } else {
        acc.others.push(question);
      }
      return acc;
    },
    {
      // Initialize other categories to empty arrays
      ...categories.reduce(
        (obj, cat) => ({ ...obj, [cat.toLowerCase()]: [] }),
        {}
      ),
    }
  );

  const handleSelect = (categories) => {
    let selectedQuestions = {}; // Reuse the state object across iterations

    categories.forEach((category) => {
      const lowerCaseCategory = category.toLowerCase(); // Calculate once outside the loop
      selectedQuestions[lowerCaseCategory] =
        filteredQuestions[lowerCaseCategory];
    });

    setSelectedQuestions(selectedQuestions); // Update state efficiently
  };

  const handleSelectAnswer = (answerForQuestion) => {
    if (answerForQuestion.request === true) {
      if (
        selectedAnswers
          .map(({ questionId }) => questionId)
          .includes(answerForQuestion.questionId)
      ) {
        setSelectedAnswers(
          selectedAnswers.map((answer) =>
            answer.questionId === answerForQuestion.questionId
              ? answerForQuestion
              : answer
          )
        );
      } else {
        setSelectedAnswers([...selectedAnswers, answerForQuestion]);
      }
    } else {
      setSelectedAnswers(
        selectedAnswers.filter(
          (answer) => answer.questionId !== answerForQuestion.questionId
        )
      );
    }
  };

  const handleOrderingChange = (newList) => {
    setSelectedAnswers(newList);
  };

  useEffect(() => {
    getAllquestions().then((allquestions) => {
      setAllQuestions(allquestions);
      setBackupQuestions(allquestions);
    });

    getTeamSurvey().then((allSurveys) => {
      let surveys = allSurveys.map((survey) => {
        return {
          answer: undefined,
          answerText: undefined,
          question: survey.question,
          questionId: survey.question_id,
          category: survey.category,
          request: true,
        };
      });
      setSelectedAnswers(surveys);
    });
  }, []);

  useEffect(() => {
    setWellnessQuestion(deleteLast)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error("Failed to update wellness question:", error);
        // Revert back to the backup copy of questions
        setAllQuestions(backupQuestions);
      });
  }, [selectedAnswers, backupQuestions,deleteLast]);

  return (
    <Tabs
      defaultActiveKey="1"
      items={[
        {
          label: `All Questions`,
          key: "all-questions",
          children: (
            <AllQuestions
              categories={categories}
              handleSelect={handleSelect}
              selectedQuestions={selectedQuestions}
              handleAnswer={handleSelectAnswer}
              selectedAnswers={selectedAnswers}
            />
          ),
        },
        {
          label: `My Survey`,
          key: `my-questions`,
          children: (
            <MySurvey
              onDelete={handleDelete}
              answersForQuestions={selectedAnswers}
              onOrderChange={handleOrderingChange}
            ></MySurvey>
          ),
        },
      ]}
    />
  );
};
